import { render, staticRenderFns } from "./default.layout.vue?vue&type=template&id=4dc228e6"
import script from "./default.layout.vue?vue&type=script&lang=ts"
export * from "./default.layout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports